<template>
  <div class="account-info">
    <template v-if="!isPageLoading">
      <div class="account-info-user">
        <div class="account-info-user-logo"></div>
        <div class="account-info-user-data">
          <div class="account-info-user-data-name">{{userInfo.nickname}}</div>
          <div class="account-info-user-data-email">{{userInfo.email}}</div>
        </div>
      </div>
      <div class="account-info-company">
        <div class="account-info-company-title">您的資訊</div>
        <div class="account-info-company-form">
          <div class="account-info-company-form-item">
            <div class="account-info-company-form-item-label">暱稱</div>
            <lgn-input class="account-info-company-form-item-value" v-model="nickname" @change.native="putMemberNickname"></lgn-input>
          </div>
          <div class="account-info-company-form-item">
            <div class="account-info-company-form-item-label">密碼</div>
            <button type="button" class="account-info-company-form-item-value main-button" @click="openPasswordDialog">修改密碼</button>
          </div>
          <template v-if="companyInfo">
            <div class="account-info-company-form-item">
              <div class="account-info-company-form-item-label">聯絡人電話</div>
              <lgn-input class="account-info-company-form-item-value" v-model="companyInfo.contact_number" @change.native="putCompanyInfo('contact_number', companyInfo.contact_number)"></lgn-input>
            </div>
            <div class="account-info-company-form-item">
              <div class="account-info-company-form-item-label">公司名稱</div>
              <lgn-input class="account-info-company-form-item-value" v-model="companyInfo.company_name" @change.native="putCompanyInfo('company_name', companyInfo.company_name)"></lgn-input>
            </div>
            <div class="account-info-company-form-item">
              <div class="account-info-company-form-item-label">統一編號</div>
              <lgn-input class="account-info-company-form-item-value" v-model="companyInfo.tax_id" @change.native="putCompanyInfo('tax_id', companyInfo.tax_id)"></lgn-input>
            </div>
            <div class="account-info-company-form-item">
              <div class="account-info-company-form-item-label">營業登記地址</div>
              <lgn-input class="account-info-company-form-item-value" v-model="companyInfo.company_address" @change.native="putCompanyInfo('company_address', companyInfo.company_address)"></lgn-input>
            </div>
          </template>
        </div>
      </div>
      <div class="account-info-service">
        <div class="account-info-service-area">
          <div class="account-info-service-area-title">服務與訂閱</div>
          <div class="account-info-service-area-content paca-table">
            <div class="paca-table__header">
              <div class="paca-table__header-item item-column column-name">項目</div>
              <div class="paca-table__header-item item-column column-enable">啟用狀態</div>
            </div>
            <div class="paca-table__body" v-if="userInfo.user_services.length != 0">
              <div class="paca-table__body-col" v-for="(item, index) in userInfo.user_services" :key="index">
                <div class="paca-table__body-col-list">
                  <div class="paca-table__body-col-list-item item-column column-name">{{serviceMapping[item.title]}}</div>
                  <div class="paca-table__body-col-list-item item-column column-enable">
                    <i class="el-icon-finished" :class="{'active': item.enable == 1}"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="paca-table__empty" v-else>暫無資料</div>
          </div>
        </div>
        <div class="account-info-service-area">
          <div class="account-info-service-area-title">申請紀錄</div>
          <div class="account-info-service-area-content paca-table">
            <div class="paca-table__header">
              <div class="paca-table__header-item item-column column-name">項目</div>
              <div class="paca-table__header-item item-column column-status">申請狀態</div>
            </div>
            <div class="paca-table__body" v-if="serviceListView.length != 0">
              <div class="paca-table__body-col" v-for="(item, index) in serviceListView" :key="index">
                <div class="paca-table__body-col-list">
                  <div class="paca-table__body-col-list-item item-column column-name">{{serviceMapping[item.services_title]}}</div>
                  <div class="paca-table__body-col-list-item item-column column-status active">{{statusMapping[item.status]}}</div>
                </div>
              </div>
            </div>
            <div class="paca-table__empty" v-else>暫無資料</div>
          </div>
        </div>
        <!-- <div class="account-info-service-title">服務與訂閱</div>
        <div class="account-info-service-table">
          <div class="paca-table">
            <div class="paca-table__header">
              <div class="paca-table__header-item item-column column-service">服務</div>
              <div class="paca-table__header-item item-column column-status">狀態</div>
              <div class="paca-table__header-item item-column column-end-time"></div>
            </div>
            <div class="paca-table__body" v-if="serviceList.length != 0">
              <div class="paca-table__body-col" v-for="(item, index) in serviceList" :key="index">
                <div class="paca-table__body-col-list" v-if="item.status != 2">
                  <div class="paca-table__body-col-list-item item-column column-service">{{serviceMapping[item.services_title]}}</div>
                  <div class="paca-table__body-col-list-item item-column column-status">{{statusMapping[item.status]}}</div>
                  <div class="paca-table__Body-col-list-item item-column column-end-time"></div>
                </div>
              </div>
            </div>
            <div class="paca-table__empty" v-else>暫無資料</div>
          </div>
        </div> -->
      </div>
    </template>
    <el-dialog class="account-info-password-dialog" :visible.sync="isPasswordDialogOpen">
      <div slot="title">更改密碼</div>
      <div class="account-info-password-dialog__body" @keyup.enter="putPassword">
        <div class="account-info-password-dialog__body-item">
          <div class="account-info-password-dialog__body-item-label">原密碼</div>
          <lgn-input type="password" class="account-info-password-dialog__Body-item-value" v-model="oldPassword"></lgn-input>
        </div>
        <div class="account-info-password-dialog__body-item">
          <div class="account-info-password-dialog__body-item-label">新密碼</div>
          <lgn-input type="password" class="account-info-password-dialog__Body-item-value" v-model="newPassword"></lgn-input>
        </div>
      </div>
      <div slot="footer">
        <button type="button" class="second-button" @click="closePasswordDialog">取消</button>
        <button type="button" class="main-button" @click="putPassword">更改密碼</button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as api from "@/script/apiService/api.js";
import lgnInput from "@/lgnComponents/lgnInput/lgnInput.vue";
export default {
  components: { lgnInput },
  name: "accountInfo",
  data() {
    return {
      userInfo: this.$store.state.userInfo,
      nickname: "",
      companyInfo: null,
      serviceList: [],
      serviceListView: [],
      statusMapping: {
        '1': '已開通',
        '0': '申請中',
      },
      isPasswordDialogOpen: false,
      oldPassword: '',
      newPassword: '',
      serviceMapping: {
        'NTP Services Reports': '新北報表',
        'Services Tokens': '憑證管理'
      },
      isPageLoading: true
    };
  },
  methods: {
    async getUserCompanyInfo(){
      let res = await api.getUserCompanyInfo();
      if(!res.error_status){
        this.companyInfo = res;
      } else if(res.error_status == '404'){
        this.companyInfo = null;
      } else if(res.error_status != '401' && res.error_status != '504'){
        this.$message.error({
          showClose: true,
          duration: 2500,
          message: "發生錯誤!"
        })
      }
    },
    async getUserService(){
      let res = await api.getUserService();
      if(!res.error_status){
        this.serviceList = res;
        this.serviceListView = [];
        let ntpItem = res.find(function(item){
          return item.services_title == 'NTP Services Reports' && item.status == 0
        }.bind(this));
        let tokenItem = res.find(function(item){
          return item.services_title == 'Services Tokens' && item.status == 0
        }.bind(this));
        if(ntpItem){
          this.serviceListView.push(ntpItem);
        }
        if(tokenItem){
          this.serviceListView.push(tokenItem);
        }
        this.$store.commit({
          type: 'setServiceList',
          serviceList: res
        })
      } else if(res.error_status != '401' && res.error_status != '504'){
        this.$message.error({
          showClose: true,
          duration: 2500,
          message: "發生錯誤!"
        })
      }
    },
    openPasswordDialog(){
      this.oldPassword = '';
      this.newPassword = '';
      this.isPasswordDialogOpen = true;
      this.$nextTick(() => {
        document.querySelector('.account-info-password-dialog .lgn-input__inner').focus();
      })
    },
    closePasswordDialog(){
      this.isPasswordDialogOpen = false;
    },
    async putPassword(){
      let vm = this;
      if(this.oldPassword.trim().length == 0 || this.newPassword.trim() == 0){
        this.$message.error({
            duration: 2500,
            showClose: true,
            message: "密碼不得為空!"
        })
        return false
      }
      let res = await api.putMemberPassword(this.oldPassword, this.newPassword);
      if(!res.error_status){
        this.isPasswordDialogOpen = false;
        this.$message.success({
          duration: 2500,
          showClose: true,
          message: "已成功更改密碼, 請重新登入",
          onClose: function(){
              vm.$store.commit({
                  type: "setUserInfo",
                  userInfo: null
              })
              vm.$router.push({name: 'Production'});
          }
        })
      } else if(res.error_status == '400'){
        this.$message.error({
          duration: 2500,
          showClose: true,
          message: "請確認輸入的內容!"
        })
      } else if(res.error_status != '401' && res.error_status != '504'){
        this.$message.error({
          duration: 2500,
          showClose: true,
          message: "發生錯誤!"
        })
      }
    },
    async putMemberNickname(){
        if(this.nickname.trim() == 0){
            this.$message.error({
                duration: 2500,
                showClose: true,
                message: "暱稱不得為空!"
            })
            return false
        }
        let data = {
            email: this.userInfo.email,
            nickname: this.nickname
        }
        let res = await api.putMemberNickname(this.id, data);
        if(!res.error_status){
            this.userInfo.nickname = this.nickname;
            this.$store.commit({
                type: 'setUserInfo',
                userInfo: this.userInfo
            });
            this.sourceNickname = this.nickname;
        } else if(res.error_status == '400'){
            this.$message.error({
                duration: 2500,
                showClose: true,
                message: "請確認輸入的內容!"
            })
        } else if(res.error_status != '401' && res.error_status != '504'){
            this.$message.error({
                duration: 2500,
                showClose: true,
                message: "發生錯誤!"
            })
        }
    },
    async putCompanyInfo(item, value){
      let data = {};
      data[item] = value;
      let res = await api.putCompanyInfo(data);
      if(!res.error_status){

      } else if(res.error_status != '401' && res.error_status != '504'){
        this.$message.error({
          showClose: true,
          duration: 2500,
          message: '發生錯誤!'
        })
      }
    },
    async getUserInfo(){
      let res = await api.getUserLogin();
      if(!res.error_status){
        res.api_token = this.$store.state.userInfo.api_token;
        this.$store.commit({
          type: "setUserInfo",
          userInfo: res
        })
        
      }
    }
  },
  async activated() {
    this.isPageLoading = true;
    await this.getUserInfo();
    this.userInfo = this.$store.state.userInfo;
    this.nickname = this.userInfo.nickname;
    await this.getUserCompanyInfo();
    await this.getUserService();
    this.isPageLoading = false;
  },
};
</script>